import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvChemistryNgLibModule } from 'sv-chemistry-ng-lib';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { SvFooterComponent } from './layout/sv-footer/sv-footer.component';
import { SvHeaderComponent } from './layout/sv-header/sv-header.component';
import { SvPageNotificationOutputComponent } from './layout/sv-page-notification-output/sv-page-notification-output.component';

@NgModule({
  imports: [
    CommonModule,
    SvChemistryNgLibModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  declarations: [
    SvFooterComponent, 
    SvHeaderComponent, 
    SvPageNotificationOutputComponent
  ],
  exports: [
    SvHeaderComponent,
    SvFooterComponent, 
    SvPageNotificationOutputComponent
  ]
})
export class CoreModule { }
